import React from 'react'
import Banner from '../components/Banner'

function home() {
  return (
    <div>
        <Banner />
    </div>
  )
}

export default home